/**
 * Loads the Lickd brand fonts (Bebas Neue for headings, Inter for everything
 * else) best-effort.
 *
 * @font-face / web-font loading is document-global (it cannot be scoped to a
 * shadow root), so we inject the stylesheet link into the host document head
 * exactly once. If it's blocked or fails, the CSS font stack falls back to
 * system fonts and the widget still renders correctly.
 */
const FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@300;400;500;600;700&display=swap";
const MARKER = "crescendo-impact-calculator-fonts";

export function ensureBrandFonts(): void {
  if (typeof document === "undefined") return;
  if (document.getElementById(MARKER)) return;
  try {
    const link = document.createElement("link");
    link.id = MARKER;
    link.rel = "stylesheet";
    link.href = FONTS_HREF;
    document.head.appendChild(link);
  } catch {
    /* fall back to system fonts */
  }
}
